/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import L from "../Lang"
import BaseCom from "../BaseCom";
import Icon from "../Icon";
import { TabsNav, TabsNavItem } from "../TabsNav";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { qreq } from "../../shared/qrequest";
import './ResultsReview.css';

class ResultsReview extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        }
    }

    async componentDidMount() {
        await this.getSettings();
        this.load();
    }

    groupList = (list) => {
        let grouped = {};
        list.forEach(row => {
            if (!grouped[row.specimen.sid])
                grouped[row.specimen.sid] = { sid: row.specimen.sid, specimen: row.specimen, rows: [] };
            grouped[row.specimen.sid].rows.push(row);
        });



        let result = [];
        for (let k in grouped) {
            if (!grouped[k].panels)
                grouped[k].panels = [];

            grouped[k].rows.forEach(row => {
                let panel = grouped[k].panels.find(a => a.id === row.panel.id);

                if (panel)
                    panel.tests.push(row);
                else
                    grouped[k].panels.push({ id: row.panel.id, code: row.panel.code, name: row.panel.name, tests: [row] });
            });
            result.push(grouped[k]);
        }

        return result;
    }

    load = async () => {
        try {
            let j = await qreq.getAsync('/api/lab/result/review/list');
            if (j.list)
                this.setState({ list: this.groupList(j.list) });
            else if (j.errorCode)
                this.alert(j.errorMesage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    toggle = (row) => {
        row.show = !row.show;
        this.setState({ list: this.state.list });
    }

    // Edit Result

    editResult = (target) => {
        target.editResult = true;
        this.setState({ list: this.state.list });
    }

    changeResult = (e, target) => {
        target.result.stringResult = e.target.value;
        this.setState({ list: this.state.list });
    }

    changeRefRange = (e, target) => {
        target.result.referenceRange = e.target.value;
        this.setState({ list: this.state.list });
    }

    changeUnits = (e, target) => {
        target.result.units = e.target.value;
        this.setState({ list: this.state.list });
    }

    changeFlags = (e, target) => {
        target.result.flags = e.target.value;
        this.setState({ list: this.state.list });
    }

    saveResult = async (target, row) => {
        try {
            let numericResult = 0;
            try {
                numericResult = parseFloat(target.result.stringResult);
                if (isNaN(numericResult))
                    numericResult = 0;
            }
            catch { }
            let j = await qreq.postAsync('/api/lab/result/save', { specimenID: row.specimen.id, targetID: target.id, stringResult: target.result.stringResult, numericResult: numericResult, referenceRange: target.result.referenceRange, units: target.result.units, flags: target.result.flags });
            if (j.errorCode === 0) {
                target.editResult = false;
                this.setState({ list: this.state.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    // Preview

    preview = (row) => {
        window.open(Globals.serverUrl + '/api/lab/report/export/' + row.specimen.id + '/' + row.specimen.sid + '.pdf');
    }

    // Render

    render() {
        return <div className="container-fluid">
            <TabsNav>
                <TabsNavItem title="All" to={'/results/review'} />
            </TabsNav>
            <h1><L>Results Review</L></h1>
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th style={{ width: '50px' }}></th>
                        <th style={{ width: '50px' }}></th>
                        <th><span className="d-none d-md-inline">{this.T('specimen')}</span><L>ID</L></th>
                        <th><L>Patient</L></th>
                        <th className="d-none d-md-table-cell"><L>Account</L></th>
                        <th className="d-none d-md-table-cell"><L>Collected</L></th>
                        <th className="d-none d-md-table-cell"><L>Received</L></th>
                    </tr>
                </thead>
                {this.state.list?.map((row, idx) => <tbody key={idx}>
                    <tr>
                        <td><span role="button" title={row.show ? 'Collapse' : 'Expand'} onClick={() => this.toggle(row)}><Icon icon={row.show ? 'faCaretDown' : 'faCaretRight'} /></span></td>
                        <td><span role="button" title="Preview Report" onClick={() => this.preview(row)}><Icon icon="faFilePdf" /></span></td>
                        <td>{row.specimen.sid}</td>
                        <td>{row.specimen.order.patient.firstName} {row.specimen.order.patient.lastName} <span className="text-muted">({row.specimen.order.patient.birthDate})</span></td>
                        <td className="d-none d-md-table-cell">{row.specimen.order.accountName}</td>
                        <td className="d-none d-md-table-cell">{Globals.toMDYHMLocalDateStringOrDiff(row.specimen.collectedDate)}</td>
                        <td className="d-none d-md-table-cell">{Globals.toMDYHMLocalDateStringOrDiff(row.specimen.receivedDate)}</td>
                    </tr>
                    {row.show && <tr>
                        <td colSpan={7}>
                            {row.panels.map((panel, idx) => <div key={'panel-' + idx}>
                                <div><strong>{panel.name}</strong></div>
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th width="20%"><L>Test</L></th>
                                            <th width="20%"><L>Result</L></th>
                                            <th width="20%"><L>Ref Range</L></th>
                                            <th width="20%"><L>Units</L></th>
                                            <th width="20%"><L>Flags</L></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {panel.tests.map((r, rdx) => <tr key={idx + '-target-' + rdx} className={r.result.flags && r.result.flags !== 'U' && r.result.flags !== '?' ? 'review-results-tr-danger' : ''}>
                                            <td>{r.name}</td>
                                            <td>
                                                {r.editResult ? <div className="input-group">
                                                    <input type="text" className="form-control" autoFocus value={r.result.stringResult} onChange={e => this.changeResult(e, r)} />
                                                    <span className="input-group-text" role="button" onClick={() => this.saveResult(r, row)}><Icon icon="faSave" /></span>
                                                </div>
                                                    : <div role="button" onClick={() => this.editResult(r)}>{r.result.stringResult ? r.result.stringResult : <i><L>None</L></i>}</div>}

                                            </td>
                                            <td>{r.editResult ? <div className="input-group">
                                                <input type="text" className="form-control" autoFocus value={r.result.referenceRange} onChange={e => this.changeRefRange(e, r)} />
                                                <span className="input-group-text" role="button" onClick={() => this.saveResult(r, row)}><Icon icon="faSave" /></span>
                                            </div> : <div role="button" onClick={() => this.editResult(r)}>{r.result.referenceRange || <i><L>None</L></i>}</div>}</td>
                                            <td>{r.editResult ? <div className="input-group">
                                                <input type="text" className="form-control" autoFocus value={r.result.units} onChange={e => this.changeUnits(e, r)} />
                                                <span className="input-group-text" role="button" onClick={() => this.saveResult(r, row)}><Icon icon="faSave" /></span>
                                            </div> : <div role="button" onClick={() => this.editResult(r)}>{r.result.units || <i><L>None</L></i>}</div>}</td>
                                            <td>{r.editResult ? <div className="input-group">
                                                <select className="form-control" onChange={e => this.changeFlags(e, r)} value={r.result.flags}>
                                                    <option value=""><L>None</L></option>
                                                    <option value="A"><L>(A) Abormal</L></option>
                                                    <option value="H"><L>(H) High</L></option>
                                                    <option value="HH"><L>(HH) Very High</L></option>
                                                    <option value="L"><L>(L) Low</L></option>
                                                    <option value="LL"><L>(LL) Very Low</L></option>
                                                    <option value="N"><L>(N) Neutral</L></option>
                                                </select>
                                                <span className="input-group-text" role="button" onClick={() => this.saveResult(r, row)}><Icon icon="faSave" /></span>
                                            </div> : <div role="button" onClick={() => this.editResult(r)}>{r.result.flags || <i><L>None</L></i>}</div>}</td>
                                        </tr>)}
                                    </tbody>
                                </table>
                            </div>)}
                        </td>
                    </tr>}
                </tbody>)}
            </table>
        </div>
    }
}

export default withParamsAndNavigate(ResultsReview);